export const GET_DEVICE = 'GET_DEVICE';
export const GET_DEVICE_SUCCESS = 'GET_DEVICE_SUCCESS';
export const GET_DEVICE_FAILURE = 'GET_DEVICE_FAILURE';

// ssid post api
export const SSID = 'SSID';
export const SSID_SUCCESS = 'SSID_SUCCESS';
export const SSID_FAILURE = 'SSID_FAILURE';

//password post api
export const PASSWORD = 'PASSWORD';
export const PASSWORD_SUCCESS = 'PASSWORD_SUCCESS';
export const PASSWORD_FAILURE = 'PASSWORD_FAILURE';

//reboot post api
export const REBOOT = 'REBOOT';
export const REBOOT_SUCCESS = 'REBOOT_SUCCESS';
export const REBOOT_FAILURE = 'REBOOT_FAILURE';

//reset post api
export const RESET = 'RESET';
export const RESET_SUCCESS = 'RESET_SUCCESS';
export const RESET_FAILURE = 'RESET_FAILURE';
